import { TriangleExclamationFill } from "@gravity-ui/icons";
import { Text, Button, Flex } from "@gravity-ui/uikit";
import { Icon } from "@gravity-ui/uikit";
import DOMPurify from "dompurify";
import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

import { useNotFoundTranslates } from "./useNotFoundTranslates.tsx";

export const NotFound = () => {
  const navigate = useNavigate();
  const { title, description, actionText } = useNotFoundTranslates();

  const sanitizedDescription = useMemo(() => {
    return {
      __html: DOMPurify.sanitize(description),
    };
  }, [description]);

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "60vh", textAlign: "center" }}
      gap={4}
    >
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Icon data={TriangleExclamationFill} size={64} />
      <Text variant="display-4" style={{ fontWeight: 700 }}>
        {title}
      </Text>
      <Text
        variant="body-2"
        style={{ marginBottom: 24 }}
        dangerouslySetInnerHTML={sanitizedDescription}
      />
      <Button view="action" size="l" onClick={handleGoHome}>
        {actionText}
      </Button>
    </Flex>
  );
};
